var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTagsIcon = function SvgTagsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tagsIcon_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5564"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1246",
    d: "M0 0h30v30H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4268",
    transform: "translate(-32.712 -720.645)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1011",
    width: 18.944,
    height: 21.645,
    rx: 2,
    transform: "translate(39.848 725.498)",
    fill: "url(#tagsIcon_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-edit",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3144",
    d: "M47.379 726.118h-8.4a2.4 2.4 0 00-2.4 2.4v16.794a2.4 2.4 0 002.4 2.4h16.794a2.4 2.4 0 002.4-2.4v-8.394",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3145",
    d: "M56.376 724.322a2.54 2.54 0 113.592 3.592l-11.375 11.375-4.789 1.197 1.2-4.789z",
    fill: "#fff"
  }))))));
};
export default SvgTagsIcon;